import * as React from 'react'
import Warning from '../../icons/auth/Warning'
import Close from '../../icons/auth/Close'
import * as classNames from 'classnames'

interface IMessageTopBarProps {
  children: any
  type: string
  isActive: boolean
  onClick?: () => void
}

interface IMessageTopBarState {
  isHidden: boolean
}

export const messageTypes: any = {
  ERROR: 'ERROR',
  WARNING: 'WARNING'
}

export class MessageTopBar extends React.Component<IMessageTopBarProps, IMessageTopBarState> {
  public state = {
    isHidden: true
  }

  public componentWillReceiveProps(newProps: IMessageTopBarProps) {
    if (newProps.isActive) {
      this.setState({ isHidden: false })
    }
  }

  public render() {
    if (this.state.isHidden) {
      return null
    }
    const { type } = this.props
    const containerClasses = classNames(
      'z3 absolute top-0 left-0 col-12 px3 py1 border-box flex items-center',
      { 'bg-red ': type === messageTypes.ERROR },
      { 'bg-white bb-dark-yellow bb-width-2': type === messageTypes.WARNING }
    )
    const iconClasses = classNames(
      { 'svg-white': type === messageTypes.ERROR },
      { 'svg-dark-yellow': type === messageTypes.WARNING }
    )
    const messageClasses = classNames(
      'bold fs-13 ml1',
      { 'font-white': type === messageTypes.ERROR },
      { 'font-dark-yellow': type === messageTypes.WARNING }
    )
    const closeIconClasses = classNames(
      { 'svg-white': type === messageTypes.ERROR },
      { 'svg-blue-grey': type === messageTypes.WARNING }
    )
    return (
      <div className={containerClasses}>
        <Warning className={iconClasses} />
        <div className={messageClasses}>{this.props.children}</div>
        <div onClick={this.handleClearError} className={'ml-auto cursor--pointer'}>
          <Close className={closeIconClasses} />
        </div>
      </div>
    )
  }

  private handleClearError = () => this.setState({ isHidden: true })
}

export default MessageTopBar



// WEBPACK FOOTER //
// ./src/components/ui/entity/MessageTopBar.tsx